module.exports = __webpack_public_path__ + "img/icon-logo.a9a23b33.svg";